//记得在 src\components\lang\zhLoad.js 里面添加对象
const menu= {
  parentMenu:"ParentMenu",
  menuNameZh: 'MenuName',
  menuNameEn:'EnglishName',
  menuNameNick:'MenuPath',
  menuModel:'MenuModel',
  hasChild:'HasChildMenu',
  displaySequence:'DisplaySequence',
  menuDepth:"MenuLevel",
  remark:'Remark',
  addMenu:'AddMenu',
  editMenu:'EditMenu',
  assignButton:'AssignButton',
  opNo:'ButtonCode',
  opName:'ButtonName',
  opType:"ButtonType",
  alias:'ButtonAlias',
  exportData:'ExportData',
  addButton:'AddCustomButton',
  selectMenuButton:'SelectMenuButton',
  menuInfo:'MenuInfo',
  no:'NO',
  yes:'YES',
  web:'web',
  miniapp:'miniapp',
  msg:{
    menuNameZh:'Please input the MenuName',
    menuNameEn:"Please input the EnglishName",
    menuNameNick:'Please input the MenuPath',
    menuModel:'Please input the MenuModel',
    hasChild:'Please select the HasChild',
    displaySequence:'Please input the DisplaySequence',
    opNo:'Please input the ButtonCode',
    opName:'Please input the ButtonName',
    alias:'Please input the ButtonAlias',
    selectButtonMsg:'Please check the menu button you want to add',
    deleteBtnMsg:'Are you sure to delete this button?',
    addMenuMsg:'Leaf node cannot add submenu'
  }
};
export default menu



// WEBPACK FOOTER //
// ./src/page/auth/menu/lang/menu.en.js